// Public form values only; no CRM source or credentials are supplied by the browser.
export function contactPayload(form, current, token) {
  const value = (name) => String(form.get(name) || "").trim();
  const url = new URL(current);
  const path = (value) => {
    try {
      if (!value || value.startsWith("(direct)")) return null;
      const candidate = new URL(value.split(" (ref=")[0], url.origin);
      return candidate.origin === url.origin ? candidate.pathname : null;
    } catch {
      return null;
    }
  };
  const refPages = {
    "ai-audit": "/audit-ia/",
    "ai-integration": "/integration-ia/",
    "ai-training": "/formation-ia/",
    "custom-software-brittany": "/logiciel-sur-mesure-bretagne/",
  };
  const origin = path(value("origin_page"));
  const landing = path(value("landing_page"));
  const english = url.pathname.startsWith("/en/");
  const refPath = refPages[url.searchParams.get("ref")];
  const page =
    (refPath && (english ? "/en" : "") + refPath) ||
    origin ||
    landing ||
    url.pathname;
  const budget = value("budget");
  const knownBudget = ["lt15000", "15000-30000", "30000-50000", "gt50000", "unknown"].includes(budget);
  const extra = [
    ["Budget indicatif / Indicative budget", knownBudget ? "" : budget.slice(0, 300)],
    ["Site web / Website", value("prospect_website").slice(0, 300)],
    ["Échéance / Timeline", value("timeline").slice(0, 100)],
    ["Page d’origine / Origin page", origin?.slice(0, 200)],
    ["Première page / Landing page", landing?.slice(0, 200)],
    [
      "Référent externe / External referrer",
      value("external_referrer").slice(0, 200),
    ],
  ]
    .filter(([, text]) => text)
    .map(([label, text]) => `${label}: ${text}`);
  return {
    project_type: value("project_type") || "other",
    budget: knownBudget ? budget : "unknown",
    name: value("name"),
    company: value("company"),
    email: value("email"),
    phone: value("phone"),
    message: [value("message").slice(0, 1800), ...extra].join("\n\n"),
    page: "https://sxnlabs.com" + page,
    website: value("website"),
    turnstile_token: token,
  };
}
